module.exports = __webpack_public_path__ + "static/media/bonus_level_1.ed569d5b.png";